import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../core';
import { ILoader } from '../../core/loader.types';
/**
 * LoderComponent
 */
@Component({
	selector: 'app-loader',
	templateUrl: './loader-component.html',
	styleUrls: ['./loader-component.scss']
})
export class LoaderComponent implements OnInit {
	constructor(loaderService: LoaderService) {
		this.loaderService = loaderService;
		this.loader = {
			isLoading: false,
			color: 'accent',
			progress: 0,
			loaderType: 'determinate'
		};
	}

	public isLoading: boolean = false;
	public loader: ILoader = {
		isLoading: false,
		color: 'accent',
		progress: 0,
		loaderType: 'determinate'
	};
	private loaderService: LoaderService;

	public ngOnInit(): void {
		this.loaderService.getLoadingStatus().subscribe((loader: ILoader) => {
			this.loader = loader;
			this.isLoading = loader ? loader.isLoading : false;
		});
	}
}
